export const CRB = 'CRB';
// Deprecated
export const SUTTON = 'SUTTON';
export const BANCORP = 'BANCORP';
export const PCL_CARD_ISSUANCE_BANKS = [CRB, BANCORP];